'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  LOGIN_WRONG_CREDENTIALS: null,
  USER_WRONG_PASSWORD: null,
  USER_PASSWORD_TOO_SHORT: null,
  USER_INVALID_EMAIL: null,
  USER_EMAIL_EXISTS: null,
  LOGIN_USER_NOT_FOUND: null,
  BAD_EMAIL: null,
  ACCOUNT_IS_USED: null,
  NOT_REGISTERED: null,
  HAS_ANOTHER_ACCOUNT: null,
  RECAPTCHA_FAILED: null
});



/** WEBPACK FOOTER **
 ** ./constants/FormMessageTypes.js
 **/